<template>
	<BuyBase
		:title="getConstants('PRICING_NEW_COMMON_ADVANCE')"
		:actions="getConstants('PRICING_NEW_TAP_CHECK_DETAIL')"
		@viewDetail="viewDetail"
		type="advance"
		class="tap-advance"
	>
		<div slot="limit">
			<p>{{ space }}</p>
			<p>{{ add }}</p>
			<UploadTip />
			<UpgradeTip
				@close="upgradeShowed = true"
				v-if="upgradeVisible"
				class="upgrade-tip-advance"
			/>
		</div>
	</BuyBase>
</template>
<script>
import BuyBase from './BuyBase'
import UploadTip from './UploadTip'
import UpgradeTip from '../UpgradeTip'
export default {
	data() {
		return {
			upgradeShowed: false,
		}
	},
	props: {
		modalShow: {
			type: Boolean,
			required: false,
		},
		upgradeVersion: {
			type: [String, null],
		},
	},
	components: {
		BuyBase,
		UploadTip,
		UpgradeTip,
	},
	methods: {
		viewDetail() {
			this.upgradeShowed = true
			this.$emit('viewDetail', 'advance')
		},
	},
	computed: {
		add() {
			let space = this.getConstants('PRICING_NEW_COMMON_ADD_SPACE') || ''
			return space.replace('%s', 2)
		},
		space() {
			let paid = this.getConstants('PRICING_NEW_COMMON_PAID_SPACE') || ''
			return paid + ' 72G'
		},
		upgradeVisible() {
			return (
				!this.modalShow &&
				this.upgradeVersion === 'advance' &&
				!this.upgradeShowed
			)
		},
	},
}
</script>
<style lang="scss" scoped>
.tap-advance {
	margin-top: 42px;
	&::before {
		background: #f1f1f1;
	}
}

.upgrade-tip-advance {
	top: 290px;
}
</style>
